export const homepageCTAHeadlines = {
  // ========================================
  // PRIORITY 1: SPECIAL EVENTS
  // ========================================
  events: {
    christmas: {
      match: (month, date) => month === 11 && date >= 24 && date <= 26,
      headline: "On Christmas.\nReally.",
    },
    christmasEve: {
      match: (month, date) => month === 11 && date === 24,
      headline: "Christmas Eve.\nSeriously?",
    },
    newYear: {
      match: (month, date) => month === 0 && date === 1,
      headline: "New year.\nSame pressure.",
    },
    newYearsEve: {
      match: (month, date) => month === 11 && date === 31,
      headline: "New Year’s Eve.\nThis can’t wait.",
    },

    birthday: {
      match: (month, date) => month === 6 && date === 16,
      headline: "It’s my birthday.\nImpress me.",
    },

    // Advertising Events
    cannes: {
    match: (month, date) => month === 5 && date >= 22 && date <= 26,
    headline: "Cannes week.\nCry privately.",
    },
    adc: {
    match: (month, date) => month === 5 && date >= 10 && date <= 11,
    headline: "ADC week.\nDon't fake it.",
    },
    dAndAd: {
    match: (month, date) => month === 4 && date >= 19 && date <= 20,
    headline: "D&AD time.\nNo bullshit.",
    },
    oneShow: {
    match: (month, date) => month === 4 && date === 15,
    headline: "One Show week.\nEveryone's watching.",
    },
  },

  // ========================================
  // PRIORITY 2: EXTREME TIMES
  // ========================================
  extremeTimes: {
    deepNight: {
      match: (hour) => hour >= 2 && hour < 3,
      headline: "2am.\nWho else is awake?",
    },
    veryLate: {
      match: (hour) => hour >= 0 && hour < 2,
      headline: "After midnight.\nThis feels urgent.",
    },
    veryEarly: {
      match: (hour) => hour >= 4 && hour < 5,
      headline: "4am.\nBrilliance hurts.",
    },
    weekendNight: {
      match: (hour, day) => (day === 6 || day === 0) && hour >= 22,
      headline: "Weekend night.\nInteresting choice.",
    },
    saturdayLate: {
      match: (hour, day) => day === 6 && hour >= 2 && hour < 5,
      headline: "3am. Saturday.\nExplain yourself.",
    },
  },

  // ========================================
  // PRIORITY 3: TIME + DAY COMBOS
  // ========================================
  timeDayCombos: {
    mondayMorning: {
      match: (hour, day) => day === 1 && hour >= 6 && hour < 10,
      headline: "Monday morning.\nHere we go.",
    },
    mondayAfternoon: {
      match: (hour, day) => day === 1 && hour >= 14 && hour < 18,
      headline: "Monday afternoon.\nKeep going.",
    },
    fridayMorning: {
      match: (hour, day) => day === 5 && hour >= 9 && hour < 12,
      headline: "Friday morning.\nStill serious.",
    },
    fridayAfternoon: {
      match: (hour, day) => day === 5 && hour >= 14 && hour < 18,
      headline: "Friday afternoon.\nDelay won’t help.",
    },
    fridayEvening: {
      match: (hour, day) => day === 5 && hour >= 18 && hour < 22,
      headline: "Friday evening.\nYou know why.",
    },
    saturdayWork: {
      match: (hour, day) => day === 6 && hour >= 9 && hour < 18,
      headline: "Saturday.\nNo one made you.",
    },
    sundayMorning: {
      match: (hour, day) => day === 0 && hour >= 6 && hour < 12,
      headline: "Sunday morning.\nAhead of most.",
    },
    sundayAfternoon: {
      match: (hour, day) => day === 0 && hour >= 12 && hour < 18,
      headline: "Sunday afternoon.\nYou’re not procrastinating.",
    },
    sundayEvening: {
      match: (hour, day) => day === 0 && hour >= 18 && hour < 23,
      headline: "Sunday night.\nMonday is watching.",
    },
    wednesday: {
      match: (hour, day) => day === 3 && hour >= 9 && hour < 18,
      headline: "Wednesday.\nYou didn’t quit.",
    },
    earlyMorning: {
      match: (hour) => hour >= 6 && hour < 9,
      headline: "Early start.\nAhead already.",
    },
    lunchTime: {
      match: (hour) => hour >= 12 && hour < 14,
      headline: "Lunch break.\nOr curiosity.",
    },
    afterWork: {
      match: (hour) => hour >= 18 && hour < 20,
      headline: "After work.\nOne more call.",
    },
    lateNight: {
      match: (hour) => hour >= 22 && hour < 24,
      headline: "Late night.\nBe honest.",
    },
  },

  // ========================================
  // PRIORITY 4: DEFAULT FALLBACK
  // ========================================
  default: "I’m listening",
};